import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "icon-mail"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NumBadge = _resolveComponent("NumBadge");

  var _component_f7_link = _resolveComponent("f7-link");

  return _openBlock(), _createBlock(_component_f7_link, {
    class: "btn-envelope",
    href: "/mail_list"
  }, {
    default: _withCtx(function () {
      return [_hoisted_1, _createVNode(_component_NumBadge, {
        absPosition: "",
        bold: "",
        num: $setup.store.state.notice_unread_num
      }, null, 8, ["num"])];
    }),
    _: 1
  });
}